import { ref, watchEffect } from 'vue'

export type ThemeMode = 'light' | 'dark'

const STORAGE_KEY = 'app-theme'
const theme = ref<ThemeMode>('light')

function applyTheme(mode: ThemeMode): void {
  document.documentElement.classList.toggle('dark', mode === 'dark')
  localStorage.setItem(STORAGE_KEY, mode)
}

export function useTheme() {
  watchEffect(() => applyTheme(theme.value))

  function initTheme(): void {
    const saved = localStorage.getItem(STORAGE_KEY) as ThemeMode | null
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    theme.value = saved ?? (prefersDark ? 'dark' : 'light')
  }

  function toggleTheme(): void {
    theme.value = theme.value === 'light' ? 'dark' : 'light'
  }

  function setTheme(mode: ThemeMode): void {
    theme.value = mode
  }

  return { theme, initTheme, toggleTheme, setTheme }
}
